<template>
  <Dialog
    v-model="currentVisible"
    :title="$t('Generate a new token')"
    width="400px"
    @before-show="onOpen"
  >
    <Form @submit="generateToken">
      <div v-if="clientSecret">
        <p>{{ $t('Your token has been generated. Take care when handling the token.') }}</p>
        <p>{{ $t('Client ID') }}: {{ clientId }}</p>
        <p>{{ $t('Client Secret') }}: {{ clientSecret }}</p>
      </div>
      <div v-else>
        <p>{{ $t('Generate a token. Take care when handling the token.') }}</p>
        <Input name="name" :max-length="20" v-model="name" required :label="$t('Token name')" />
      </div>
      <div class="text-right q-gutter-sm q-mt-sm" v-if="!clientSecret">
        <Button :label="$t('Cancel')" color="standard" flat @click="currentVisible = false" />
        <Button :label="$t('Generate')" type="submit" :disabled="loading" :loading="loading" />
      </div>
    </Form>
  </Dialog>
</template>

<script>
import { mapActions } from 'vuex';
import Button from '@design-system/components/Button.vue';
import Dialog from '@design-system/components/Dialog.vue';
import Form from '@design-system/components/Form.vue';
import Input from '@design-system/components/Input.vue';

const messages = {
  en: {
    'Generate a new token': 'Generate a new token',
    'Token name': 'Token name',
    'Generate a token. Take care when handling the token.':
      'Generate a token. Take care when handling the token.',
    'Your token has been generated. Take care when handling the token.':
      'Your token has been generated. Take care when handling the token.',
    Cancel: 'Cancel',
    Generate: 'Generate',
  },
  ja: {
    'Generate a new token': '新しいトークンの作成',
    'Token name': 'トークン名',
    'Generate a token. Take care when handling the token.':
      'トークンを作成します。トークンの取り扱いには十分注意してください。',
    'Your token has been generated. Take care when handling the token.':
      'トークンが作成されました。トークンの取り扱いには十分注意してください。',
    Cancel: 'キャンセル',
    Generate: '発行',
  },
};

export default {
  name: 'UserClients',
  components: { Button, Dialog, Form, Input },
  i18n: { messages },
  props: {
    value: Boolean,
  },
  data() {
    return {
      name: '',
      clientSecret: '',
      loading: false,
    };
  },
  computed: {
    currentVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    ...mapActions('userClients', {
      generateClient: 'generateClient',
      fetchClients: 'fetchClients',
    }),
    onOpen() {
      this.name = '';
      this.clientId = '';
      this.clientSecret = '';
    },
    async generateToken() {
      const { clientId, clientSecret } = await this.generateClient(this.name);
      this.clientId = clientId;
      this.clientSecret = clientSecret;
      await this.fetchClients();
    },
  },
};
</script>
